import "../../App.css";
import React from "react";
import CHILD_DENTISTRY from "../CHILD_DENTISTRY";
import CONTACT_US from "../footer";
import Accordian from "../../accordian/accordian";
import ScrollArrow from "../ScrollUp";
import BackBtn from "../BackBtn";

function CHILD_DENTISTRY_Page() {
  return (
    <>
      <CHILD_DENTISTRY />
      <Accordian
        title="What ages of children do child dentists treat "
        content="A child dental specialist practitioner will treat patients from birth through youth. Child Dentistry prescribes that youthful patients start visiting a child dental specialist when most youngsters have a first tooth. Youngsters should keep on visiting the dental specialist occasionally all through adolescence to avoid tooth rot and gum sickness."
      />
      <Accordian
        title=" What type of training does a child dentist have"
        content="  A child dental specialist practitioner is equivalent to a family dental specialist, just with two extra-long stretches of preparing particularly in the oral treatment of infants, kids, adolescents, and children with exceptional requirements. They are prepared to comprehend the dental needs of a kid as well as the mental and enthusiastic needs also."
      />
      <BackBtn />
      <CONTACT_US />
      <ScrollArrow />
    </>
  );
}
export default CHILD_DENTISTRY_Page;
